import EnhancedTable from 'lib/designSystem/Table';
import { formatDate } from 'lib/functions/utils';
import React, { useState } from 'react';

import DocumentDialog from './components/DocumentDialog';

const ReportAccruingTable = (props: any) => {
  const { rows, headers, dailyLinesByDocumentId, startDate, endDate } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [selectedRowLines, setSelectedRowLines] = useState<any>(null);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleClickRow = (id: any) => {
    const rowData = rows.find((r: any) => r.id === id);
    setSelectedRow(rowData);
    setSelectedRowLines(dailyLinesByDocumentId[id]);
    setOpenDialog(true);
  };

  return (
    <div style={{ paddingBottom: 100 }}>
      <EnhancedTable
        dataHeaders={headers}
        data={rows}
        finalSumRow
        rowsPerPageDefault={500}
        rowsPerPageOptions={[500, 1000]}
        handleClickRow={handleClickRow}
        exportToFile="xlsx"
        fileName={`reporte_ingresos_por_devengo_${formatDate(new Date(startDate))}_${formatDate(new Date(endDate))}.xlsx`}
      />
      {selectedRow && openDialog && (
        <DocumentDialog
          row={selectedRow}
          openDialog={openDialog}
          handleCloseDialog={handleCloseDialog}
          lines={selectedRowLines}
        />
      )}
    </div>
  );
};

export default ReportAccruingTable;
